// extracted by mini-css-extract-plugin
export default {"headerModal":"MessageErrorModal_headerModal__ldlmN","bodyModal":"MessageErrorModal_bodyModal__kJDTF"};